import {createAction, props} from '@ngrx/store';
import {DeviceFilter} from './device.state';
import {WsDeviceDto} from '../../../core/models/interfaces/ws-device-dto.interface';
import {DeviceListResponseDto, DeviceResponseDto, DeviceUpdateRequest} from '../models/device-response.interface';

const ACTION_PREFIX = '[Device]';

type UpdateDeviceActionPayload = Omit<DeviceUpdateRequest, 'type'> & {
  deviceType?: DeviceUpdateRequest['type'];
};

export const DeviceActions = {
  public: {
    updateDeviceFilter: createAction(
      `${ACTION_PREFIX} updateDeviceFilter`,
      props<{
        filter: DeviceFilter
      }>(),
    ),

    loadAllDevicesByFilters: createAction(
      `${ACTION_PREFIX} loadAllDevicesByFilters`,
      props<{
        filter: DeviceFilter
      }>(),
    ),

    triggerDeviceAction: createAction(
      `${ACTION_PREFIX} triggerDeviceAction`,
      props<{
        id: string,
        value: boolean,
      }>(),
    ),

    updateDevice: createAction(
      `${ACTION_PREFIX} updateDevice`,
      props<UpdateDeviceActionPayload>(),
    ),

    loadDeviceById: createAction(
      `${ACTION_PREFIX} loadDeviceById`,
      props<{
        id: string,
      }>(),
    ),

    deleteDeviceById: createAction(
      `${ACTION_PREFIX} deleteDeviceById`,
      props<{
        id: string
      }>(),
    ),

    refreshDeviceDataFromWebSocket: createAction(
      `${ACTION_PREFIX} refreshDeviceDataFromWebSocket`,
      props<{
        device: WsDeviceDto
      }>(),
    ),
  },

  private: {
    loadDevicesWithFilters: createAction(
      `${ACTION_PREFIX} loadDevicesWithFilters`,
    ),

    loadDevicesSuccess: createAction(
      `${ACTION_PREFIX} loadDevicesSuccess`,
      props<{ devicesResponseDto: DeviceListResponseDto }>(),
    ),

    loadDevicesFailure: createAction(
      `${ACTION_PREFIX} loadDevicesFailure`,
      props<{ error: any }>(),
    ),

    loadDevicesWithProvidedFilters: createAction(
      `${ACTION_PREFIX} loadDevicesWithProvidedFilters`,
      props<{
        filter: DeviceFilter
      }>(),
    ),

    loadDevicesWithProvidedFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadDevicesWithProvidedFiltersSuccess`,
      props<{ devicesResponseDto: DeviceListResponseDto }>(),
    ),

    loadDevicesWithProvidedFiltersFailure: createAction(
      `${ACTION_PREFIX} loadDevicesWithProvidedFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadAllDevicesByFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadAllDevicesByFiltersSuccess`,
    ),

    loadAllDevicesByFiltersFailure: createAction(
      `${ACTION_PREFIX} loadAllDevicesByFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadNextOfAll: createAction(
      `${ACTION_PREFIX} loadNextOfAll`,
      props<{
        page: number,
        filter: DeviceFilter
      }>(),
    ),

    loadNextOfAllSuccess: createAction(
      `${ACTION_PREFIX} loadNextOfAllSuccess`,
      props<{ devicesResponseDto: DeviceListResponseDto }>(),
    ),

    loadNextOfAllFailure: createAction(
      `${ACTION_PREFIX} loadNextOfAllFailure`,
      props<{ error: any }>(),
    ),

    deleteDeviceSuccess: createAction(
      `${ACTION_PREFIX} deleteDeviceSuccess`,
      props<{
        id: string,
      }>(),
    ),

    deleteDeviceFailure: createAction(
      `${ACTION_PREFIX} deleteDeviceFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    triggerDeviceActionSuccess: createAction(
      `${ACTION_PREFIX} triggerDeviceActionSuccess`,
      props<{
        responseDto: DeviceResponseDto,
      }>(),
    ),

    triggerDeviceActionFailure: createAction(
      `${ACTION_PREFIX} triggerDeviceActionFailure`,
      props<{
        id: string,
        attemptedValue: boolean,
        error: any,
      }>(),
    ),

    updateDeviceSuccess: createAction(
      `${ACTION_PREFIX} updateDeviceSuccess`,
      props<{
        responseDto: DeviceResponseDto,
      }>(),
    ),

    updateDeviceFailure: createAction(
      `${ACTION_PREFIX} updateDeviceFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    loadDeviceByIdSuccess: createAction(
      `${ACTION_PREFIX} loadDeviceByIdSuccess`,
      props<{
        responseDto: DeviceResponseDto,
      }>(),
    ),

    loadDeviceByIdFailure: createAction(
      `${ACTION_PREFIX} loadDeviceByIdFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),
  }
}
